<template>
    <rkm-table
        :fields="fields"
        :items="data.model.supervisores"
        sort-by="usuario.cidadaoNome"
    >
        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click="destroy(item)"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-table>
</template>

<script>
export default {
    data: () => ({
        fields: [
            { key: 'usuario.cidadaoNome', label: 'Nome', sortable: true },
            { key: 'actions', label: 'Ações', class: 'col-min text-center' },
        ],
    }),
    methods: {
        destroy(supervisor) {

            this.showDeleteConfirmation(
                'Deseja realmente excluir o supervisor?',
                async () => this.data.model.supervisores.splice(this.data.model.supervisores.indexOf(supervisor), 1)
            )
        }
    },
    props: {
        data: { type: Object, required: true },
    }
}
</script>